import type { WorkloadDetailsRequest, WorkloadDetailsResponse } from '../../types/workload'

import { apiClient } from '../api/apiClient'
import { logger } from '../../utils/logger'

export const workloadService = {
  async getWorkloadDetails(request: WorkloadDetailsRequest): Promise<WorkloadDetailsResponse> {
    try {
      logger.log('Fetching workload details:', request)

      const params = new URLSearchParams({
        gitRepo: request.gitRepo,
        environment: request.environment,
        workload: request.workload,
        ...(request.limit && { limit: request.limit.toString() }),
        ...(request.offset && { offset: request.offset.toString() })
      })

      // apiClient unwraps response.data, so we get the WorkloadDetailsResponse directly
      const response = await apiClient.get<WorkloadDetailsResponse>(
        `/devtools/packages/workloads?${params.toString()}`
      )

      logger.log('Workload details API response:', response)
      logger.log('Response type:', typeof response)
      logger.log('Response keys:', Object.keys(response))

      // The response is already the full object with data, total, limit, etc.
      return response
    } catch (error) {
      logger.error('Failed to fetch workload details:', error)
      throw new Error('Failed to fetch workload details. Please try again later.')
    }
  }
}

